const methods = ({ request }) => ({

  getAdminData: async () => request('AdminData'),

  getNav: async () => request('WP/Nav'),

  getPositions: async () => request('Player/GetPositions'),

  getCurrentSeason: async () => request('Season/Current'),

  getSeasons: async () => request('Season/GetSeasons'),

  getSeasonWeeks: async year => request(`Season/GetWeeks/${year}`),

  getTeams: async () => request('Teams'),

  getToolDescriptions: async () => request('Tools'),

  getMatchups: async ({ year, week }) => request(`GameScans/Matchups/${year}/${week}`),

  getPositionStatsMap: async view => request(`Stats/ToolPositionStatMap/${view}`),

});

export default methods;



// WEBPACK FOOTER //
// ./src/lib/api/lookups.js